import {TablePaginationConfig} from 'antd/es/table/interface';
import React from 'react';

import {IDefaultTableState, IDefaultTableStateFlat} from 'modules/data/data-types';
import {ReactComponent as ArrowRightIcon} from 'shared/assets/arrow-right.svg';
import {usePagination} from 'shared/hooks/use-pagination';

interface IEditableTablePagination {
    params?: IDefaultTableStateFlat;
    isPageJumperEnabled?: boolean;
    isPageSizeChangerEnabled?: boolean;
    isPaginationDisabled?: boolean;
    tableState:  IDefaultTableState;
    onChange: (page?: number | undefined, pageSize?: number | undefined) => void;
    paginationConfig?: IDefaultTableStateFlat | undefined;
    totalElements?: number;
}

export const useEditableTablePagination = ({
    params,
    isPaginationDisabled,
    isPageJumperEnabled,
    isPageSizeChangerEnabled,
    onChange,
    // Параметры из меты
    tableState,
    // Параметры из конфига
    paginationConfig,
    totalElements,
}: IEditableTablePagination): TablePaginationConfig | undefined | false => {

    const {current, pageSize, handleChange} = usePagination({
        pageSizeDefault: paginationConfig?.paginationPageSize,
        pageDefault: paginationConfig?.paginationCurrent,
        onChange,
    });

    if (isPaginationDisabled) {
        return false;
    }

    return {
        position: ['bottomLeft'],
        locale: {
            items_per_page: 'на странице',
            jump_to: ''
        },
        showQuickJumper: isPageJumperEnabled ? {
            goButton: <ArrowRightIcon className="pagination_jumper" />
        } : false,
        showSizeChanger: isPageSizeChangerEnabled,
        current: params?.paginationCurrent || current || tableState?.pagination?.current,
        pageSize: params?.paginationPageSize || pageSize || tableState?.pagination?.pageSize,
        total: tableState?.pagination?.total || totalElements,
        onChange: handleChange,
    };
};